import React from 'react';

export const NavigationContext = React.createContext({
  navigation: {},
  navigationGroup: {},
  isButtonGroupingSupported: false,
  suggestions: [],
});

export const NavigationProvider = NavigationContext.Provider;
